<script>
	import { page } from '$app/stores'
	import { PUBLIC_SUPABASE_URL } from '$env/static/public'
	import License from '$lib/components/License.svelte'
	import Patron from '$lib/components/Patron.svelte'
	import ProBadge from '$lib/components/ProBadge.svelte'
	import ProductButton from '$lib/components/ProductButton.svelte'
	import User from '$lib/components/User.svelte'
	import Video from '$lib/components/Video.svelte'
	import { Badge } from '$lib/shadcn/ui/badge'
	import { Button } from '$lib/shadcn/ui/button'
	import {
		ShieldCheckIcon,
		SquareDashedMousePointerIcon,
	} from 'lucide-svelte'

	export let data
</script>

<svelte:head>
	<title>Scenery - {data.item.name}</title>
	<!-- Twitter -->
	<meta name="twitter:card" content="summary" />
	<meta name="twitter:site" content="@scenery_io" />
	<!-- OpenGraph -->
	<meta property="og:type" content="website" />
	<!-- TODO: Fetch smaller image from storage -->
	<meta property="og:image" content="{data.item.storageUrl}/poster.png" />
	<meta property="og:url" content={$page.url.href} />
	<meta
		property="og:title"
		content="{data.item.name} by @{data.item.user.username}"
	/>
	<meta
		property="og:description"
		content="Download '{data.item
			.name}' from Scenery. The community for Cavalry."
	/>
</svelte:head>

{#if !data.item.approved}
	<div class="flex justify-center px-7 py-12 m-auto mt-16">
		<div>
			<h2
				class="font-bold text-2xl flex justify-center items-center -ml-4"
			>
				<ShieldCheckIcon />
				<span class="ml-2">Awaiting Approval</span>
			</h2>
			<p class="m-2 text-muted-foreground text-lg">
				This asset has not yet been approved.
			</p>
		</div>
	</div>
{:else}
	<div class="flex justify-center px-7 mt-10 mb-8 sm:mb-16">
		<div
			class="flex flex-col border items-center lg:items-start lg:flex-row rounded-md w-full lg:w-fit"
		>
			<Video url={data.item.storageUrl} fit={false} autoplay />
			<div
				class="flex flex-col justify-start py-5 rounded-sm w-full h-fit lg:h-full lg:max-w-md lg:border-l"
			>
				<div class="px-8">
					<User size="s" username={data.item.user.username} />
					<h2
						class="leading-tight text-2xl mt-6 font-medium inline-flex items-center"
					>
						{data.item.name}
					</h2>
				</div>
				<div class="flex flex-col gap-6 mt-6">
					<div class="border-t border-b px-8 py-6">
						<License
							name={data.item.name}
							realname={data.item.user.realname}
							code={data.item.license.code}
							url={data.item.license.url}
						/>
					</div>
					<div class="flex flex-wrap gap-2 px-8">
						<!-- TODO: Button disappears when scene is paid -->
						{#if data.item.downloadable}
							<ProductButton
								{...data.item}
								category={data.category}
							/>
						{/if}
						{#if data.item.collection}
							<Button
								href="/collections/{data.item.collection.slug}"
								variant={data.item.downloadable
									? 'secondary'
									: 'default'}
							>
								View Collection
							</Button>
						{/if}
						{#if data.graph}
							<Button
								variant="secondary"
								class="w-fit"
								href="/graphs/{data.item.slug}"
							>
								<SquareDashedMousePointerIcon
									size="20"
									class="mr-2"
								/>
								Scene Graph
							</Button>
						{/if}
					</div>
				</div>
				<div class="mt-8 px-8">
					<h3 class="mb-3 text-muted-foreground text-sm">
						Made in Cavalry {data.item.cavalry_version} with
					</h3>
					<div class="flex flex-wrap gap-[6px] mb-3 overflow-y-auto">
						{#each data.item.nodes as node}
							<Badge
								variant="secondary"
								class="pl-0 pr-2 border-opacity-20"
								category={node.category}
								href="/scenes?node={node.id}"
							>
								<img
									src="{PUBLIC_SUPABASE_URL}/storage/v1/object/public/assets/nodes/{node.id}.svg"
									class="h-[18px] w-[18px] mx-1"
									loading="lazy"
									alt=""
								/>
								{node.name}
								{#if node.pro}
									<ProBadge />
								{/if}
							</Badge>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
	{#if !data.patron}
		<Patron />
	{/if}
{/if}
